module.exports = __webpack_public_path__ + "static/media/clock-counterclockwise.5a164ca1.svg";